const initialData: IApplicationData = {
  id: '',
  ownerId: '',
}

export interface IApplicationData {
  id: string
  ownerId: string
}

export const createApplicationData = (data?: Partial<IApplicationData>): IApplicationData => ({
  ...initialData,
  ...data,
})
